var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSelectLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 21,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4264FD",
  fillRule: "evenodd",
  d: "M10.5 2a4.21 4.21 0 0 0-4.2 4.2 4.21 4.21 0 0 0 3.6 4.157V15.6a.6.6 0 0 0 1.2 0v-5.243A4.21 4.21 0 0 0 14.7 6.2c0-2.313-1.887-4.2-4.2-4.2m0 1.2c1.664 0 3 1.336 3 3s-1.336 3-3 3-3-1.336-3-3 1.336-3 3-3",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#4264FD",
  fillRule: "evenodd",
  d: "M6.722 14.686c-.616.184-1.12.408-1.512.7-.392.293-.71.704-.71 1.214 0 .492.296.891.653 1.172s.807.493 1.34.67c1.063.355 2.462.558 4.007.558s2.944-.203 4.008-.557c.532-.178.983-.39 1.34-.67.356-.282.652-.68.652-1.173 0-.51-.318-.921-.71-1.214s-.896-.516-1.512-.7a.6.6 0 1 0-.344 1.15c.525.156.918.347 1.137.511.22.165.229.253.229.253 0 .006-.006.08-.196.23s-.53.325-.976.474c-.89.296-2.191.496-3.628.496s-2.738-.2-3.628-.496c-.445-.149-.787-.324-.977-.474s-.195-.224-.195-.23c0 0 .008-.088.228-.253.22-.164.612-.355 1.138-.512a.599.599 0 1 0-.344-1.15",
  clipRule: "evenodd"
})));
export default SvgIconSelectLocation;